var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 62,
    viewBox: "0 0 107 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1691_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.748 5.26883L4.60912 23.3325C0.31112 27.6126 0.31112 34.5522 4.60912 38.8323L22.748 56.896C27.046 61.1761 34.0144 61.1761 38.3124 56.896L56.4512 38.8323C60.7492 34.5522 60.7492 27.6126 56.4512 23.3325L38.3124 5.26883C34.0144 0.988657 27.046 0.988656 22.748 5.26883Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.748 5.26883L4.60912 23.3325C0.31112 27.6126 0.31112 34.5522 4.60912 38.8323L22.748 56.896C27.046 61.1761 34.0144 61.1761 38.3124 56.896L56.4512 38.8323C60.7492 34.5522 60.7492 27.6126 56.4512 23.3325L38.3124 5.26883C34.0144 0.988657 27.046 0.988656 22.748 5.26883Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5383 23.7204V38.4722C20.5383 39.8937 21.6955 41.0461 23.123 41.0461H37.9363C39.3637 41.0461 40.5209 39.8937 40.5209 38.4722V23.7204C40.5209 22.2988 39.3637 21.1464 37.9363 21.1464H23.123C21.6955 21.1464 20.5383 22.2988 20.5383 23.7204Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6375 17.6315C55.5289 8.44273 65.2562 2.18774 76.4286 2.18774C92.5481 2.18774 105.61 15.1959 105.61 31.2485C105.61 47.3012 92.5481 60.3093 76.4286 60.3093C65.2562 60.3093 55.5289 54.0543 50.6375 44.8656",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6787 36.5348C81.7593 36.5348 85.8779 32.4332 85.8779 27.3737C85.8779 22.3142 81.7593 18.2126 76.6787 18.2126C71.5981 18.2126 67.4795 22.3142 67.4795 27.3737C67.4795 32.4332 71.5981 36.5348 76.6787 36.5348Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9073 56.4622C88.9073 49.5983 83.321 44.0076 76.4008 44.0076C69.4805 44.0076 63.8943 49.5706 63.8943 56.4622",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1691_1451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 61,
    fill: "white",
    transform: "translate(0 0.693115)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.d4dd52325b99b3bbdb38e3ff7b8fc504.svg";
export { ForwardRef as ReactComponent };